import React from "react";
import css from "./FeatureExplorer.module.css";
import SectionView from "./SectionView/SectionView";
import TypeText from "./TypeText/TypeText";
import {capitalize} from "vritra";
import {Title,TextView} from "Components";
import {tube0,chevron0} from "Assets";


export default function FeatureExplorer(props){
    const {feature=props.cherry,back}=props,{name,type,parent,description,preview}=feature;
    return (
        <div className={`${css.featureexplorer} ${props.className||""}`}>
            <div className={css.header}>
                {back&&<img 
                    className={`button ${css.backbtn}`} 
                    alt="back"
                    src={chevron0(textColor,1.5)}
                    onClick={()=>{history.back()}}
                />}
                {name&&<Title className={css.title}>{name}</Title>}
                {feature.experimental&&
                    <img 
                        className={css.experimentalicon} 
                        src={tube0(mainColor)}
                        title={capitalize(language.experimantal)+" : "+language.mayresultinunexpectedbehavior}
                    />
                }
                {feature.typedynamic&&
                    <span className={css.typevar}>
                        <span id="sign">{"<"}</span>
                        <span>Type</span>
                        <span id="sign">{">"}</span>
                    </span>
                }
                {type&&<TypeText 
                    className={css.type} 
                    style={{fontSize:"4em"}} 
                    type={type}
                />}
                {parent&&<>
                    <span className={css.typevar}>extends</span>
                    <TypeText 
                        className={css.type} 
                        style={{fontSize:"6em"}} 
                        type={parent}
                    />
                </>}
            </div>
            {description&&<TextView className={css.description} text={description}/>}
            {preview&&getPreview(preview,"top")}
            {feature.sections?.map(({title,fields},i)=>fields&&
                <SectionView 
                    key={(title||"")+i} 
                    title={title} 
                    fields={fields}
                />
            )}
            {preview&&getPreview(preview,"bottom")}
        </div>
    )
}

const getPreview=(preview,pos)=>{
    const {title="preview",component=preview,code,image,position="top"}=typeof(preview)==="function"?{}:preview;
    return (position===pos)&&<SectionView 
        title={title||"preview"}
        image={image}
        code={code}
        onMount={typeof(component)==="function"?((element)=>{component({parent:element})}):undefined}
    />
}
